import { motion } from 'framer-motion';
import { LucideIcon } from 'lucide-react';
import styles from './ContactInfoCard.module.css';

interface ContactInfoCardProps {
  icon: LucideIcon;
  title: string;
  content: string;
  description: string;
  delay?: number;
}

export function ContactInfoCard({ icon: Icon, title, content, description, delay = 0 }: ContactInfoCardProps) {
  return (
    <motion.div
      className={styles.card}
      initial={{ y: 20, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      whileHover={{ 
        y: -4,
        boxShadow: '0 12px 40px rgba(255, 154, 86, 0.15)'
      }}
    >
      <div className={styles.iconWrapper}>
        <Icon className={styles.icon} size={24} />
      </div>
      <div className={styles.content}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.mainContent}>{content}</p>
        <p className={styles.description}>{description}</p>
      </div>
    </motion.div>
  );
}
